import React, { useState, useEffect, useRef } from "react";
import { V2Button } from "@abyss/web/ui/Button";
import { IconSymbol } from "@abyss/web/ui/IconSymbol";
import { V2Link } from "@abyss/web/ui/Link";

import styles from "./floatingchat.module.css";

import classNames from "classnames";
import { PlanDetail } from "../PlanDetail";
import { VoteButtons } from "./VoteButtons";

const dataQuestions = [
  {
    id: "1",
    content: `<span>What is the copay for specialists?</span>`,
  },
  {
    id: "2",
    content: `<span>What is the annual prescription deductible?</span>`,
  },
  {
    id: "3",
    content: `<span>What is the in-network copay for insulin?</span>`,
  },
];

const dataResponses = [
  {
    id: "1",
    content: `<div>
        The copay for specialist visits is
        <span style="font-weight: 700;">$30 for in-network providers</span> and
        <span style="font-weight: 700;">$55 for out-of-network providers.</span>
        These amounts apply until you reach the out-of-pocket maximum.
      </div>`,
  },
  {
    id: "2",
    content: `<div>
        <div>
          For the
          <span style="color: #196ecf; font-weight: 700;">
            AARP® Medicare Advantage from UHC MN-0005 (PPO)
          </span>
          plan you're reviewing, here are the details for your prescription drug
          deductible:
        </div>
        <ul style="list-style: disc; padding-left: 25px; padding-block: 10px;">
          <li>
            <span style="font-weight: 700;">Pharmacy Deductible:</span> There is a
            $340 annual deductible that applies to Tier 3, Tier 4, and Tier 5
            drugs. For Tier 1 and Tier 2 drugs, no deductible is applied
          </li>
          <li>
            <span style="font-weight: 700;">Medical Deductible:</span> This plan
            does not have a medical deductible.
          </li>
        </ul>
        <div>
          These details ensure that once you pay $340 for the applicable tiers
          of prescriptions, you move on to the next stage of coverage for your
          drugs.
        </div>
      </div>`,
  },
  {
    id: "3",
    content: `<div>
        If you would like to learn more about drug costs, use our Drug Cost
        Estimator tool.
        <div>
          <button style="display: flex;
height: 40px;
padding: 8px 16px;
justify-content: center;
align-items: center;
gap: 8px; border-radius: 24px; border: 1px solid #002677; background: #fff; color: #002677; font-weight: 700; margin-top: 10px; font-size: 16px;
">Add your drugs</button>
        </div>
      </div>`,
  },
];

export const FloatingChatB = () => {
  const [chatVisible, setChatVisible] = useState(true);
  const [chatSelected, setChatSelected] = useState("all");
  const [response, setResponse] = useState([]);

  const containerRef = useRef(null);
  const loadingRefs = useRef([]);
  const answerRefs = useRef([]);

  const toggleChatWindow = () => {
    setChatVisible(!chatVisible);
  };

  const showAnswer = (number) => {
    setChatSelected(number);

    const foundQuestion = dataQuestions?.find(
      (item) => item?.id === number
    )?.content;
    const foundAnswer = dataResponses?.find(
      (item) => item?.id === number
    )?.content;

    setResponse([
      ...response,
      { question: foundQuestion, answer: foundAnswer },
    ]);
  };

  const typedAnswer = (e) => {
    e.preventDefault();

    setChatSelected("typed");

    setResponse([
      ...response,
      {
        question: e.target[0].value,
        answer:
          "<div>I can answer questions about Medicare Advantage plans. For more coverage information, please refer to the source documents below.</div>",
      },
    ]);

    e.target[0].value = "";
  };

  return (
    <React.Fragment>
      <PlanDetail />
      <div className={styles.samButtons}>
        <div>
          <button onClick={toggleChatWindow}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M16.7075 13.6986C13.1142 13.6986 10.1995 10.7839 10.1995 7.19062C10.1995 7.08862 10.1171 7.00232 10.0112 7.00232C9.90527 7.00232 9.82289 7.0847 9.82289 7.19062C9.82289 10.7839 6.90821 13.6986 3.31488 13.6986C3.21289 13.6986 3.12659 13.781 3.12659 13.8869C3.12659 13.9928 3.20897 14.0752 3.31488 14.0752C6.90821 14.0752 9.82289 16.9899 9.82289 20.5832C9.82289 20.6852 9.90527 20.7715 10.0112 20.7715C10.1171 20.7715 10.1995 20.6891 10.1995 20.5832C10.1995 16.9899 13.1142 14.0752 16.7075 14.0752C16.8095 14.0752 16.8958 13.9928 16.8958 13.8869C16.8958 13.781 16.8134 13.6986 16.7075 13.6986Z"
                fill="white"
              />
              <path
                d="M20.0536 7.04152C18.2884 7.04152 16.8565 5.60968 16.8565 3.84439C16.8565 3.7934 16.8134 3.75024 16.7624 3.75024C16.7114 3.75024 16.6682 3.7934 16.6682 3.84439C16.6682 5.60968 15.2364 7.04152 13.4711 7.04152C13.4201 7.04152 13.377 7.08467 13.377 7.13566C13.377 7.18666 13.4201 7.22981 13.4711 7.22981C15.2364 7.22981 16.6682 8.66165 16.6682 10.4269C16.6682 10.4779 16.7114 10.5211 16.7624 10.5211C16.8134 10.5211 16.8565 10.4779 16.8565 10.4269C16.8565 8.66165 18.2884 7.22981 20.0536 7.22981C20.1046 7.22981 20.1478 7.18666 20.1478 7.13566C20.1478 7.08467 20.1046 7.04152 20.0536 7.04152Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div>
          <button>
            <IconSymbol
              icon="chat"
              color="white"
              size="24px"
              variant="outlined"
            />
          </button>
        </div>
        <div>
          <button>
            <IconSymbol
              icon="phone"
              color="white"
              size="24px"
              variant="outlined"
            />
          </button>
        </div>
      </div>
      <div>
        <div
          className={classNames(
            styles.floatboxB,
            chatVisible ? styles.isVisible : ""
          )}
        >
          <div className={styles.floatboxInner}>
            <div className={styles.floatboxHd}>
              <div className={styles.floatboxHdUpper}>
                <div className={styles.floatboxTitle}>
                  Do you have questions?
                </div>
                <div className={styles.floatboxClose}>
                  <div
                    className={styles.chatboxClose}
                    onClick={() => {
                      setChatVisible(false);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="39"
                      height="39"
                      viewBox="0 0 39 39"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_6993_30597)">
                        <path
                          d="M27 13.5107L25.4893 12L19.5 17.9893L13.5107 12L12 13.5107L17.9893 19.5L12 25.4893L13.5107 27L19.5 21.0107L25.4893 27L27 25.4893L21.0107 19.5L27 13.5107Z"
                          fill="#196ECF"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6993_30597">
                          <rect width="38.75" height="38.75" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.floatboxBd}>
              {chatSelected === "all" && (
                <div className={styles.floatboxItems}>
                  <div
                    className={styles.floatQuestionB}
                    onClick={() => showAnswer("1")}
                  >
                    <div className={styles.floatQuestionCopyB}>
                      <span>What is the copay for specialists?</span>
                      <IconSymbol icon="arrow_forward" variant="outlined" />
                    </div>
                  </div>
                  <div
                    className={styles.floatQuestionB}
                    onClick={() => showAnswer("2")}
                  >
                    <div className={styles.floatQuestionCopyB}>
                      <span>What is the prescription deductible?</span>
                      <IconSymbol icon="arrow_forward" variant="outlined" />
                    </div>
                  </div>
                  <div
                    className={styles.floatQuestionB}
                    onClick={() => showAnswer("3")}
                  >
                    <div className={styles.floatQuestionCopyB}>
                      <span>What is the in-network copay for insulin?</span>
                      <IconSymbol icon="arrow_forward" variant="outlined" />
                    </div>
                  </div>
                </div>
              )}

              <div className={styles.responseItems}>
                {response.map((item, index) => (
                  <div key={index}>
                    <div className={styles.questionContain}>
                      <div
                        className={styles.question}
                        dangerouslySetInnerHTML={{ __html: item?.question }}
                      ></div>
                    </div>
                    <div
                      className={styles.snippet}
                      ref={(element) =>
                        (loadingRefs.current[item.id] = element)
                      }
                    >
                      <div className={styles.stage}>
                        <div className={styles.dotTyping}></div>
                      </div>
                    </div>
                    <div
                      className={styles.answerWrap}
                      ref={(element) => (answerRefs.current[item.id] = element)}
                    >
                      <div
                        className={styles.answer}
                        dangerouslySetInnerHTML={{ __html: item?.answer }}
                      ></div>
                      <VoteButtons />
                    </div>
                  </div>
                ))}
              </div>
              <div ref={containerRef}></div>
            </div>
            <div className={styles.floatboxFt}>
              <div className={styles.textInput}>
                <form onSubmit={typedAnswer}>
                  <input type="text" placeholder="Type your question here" />
                  <div className={styles.textInputIcons}>
                    <IconSymbol icon="keyboard_voice" variant="outlined" />
                    <IconSymbol icon="send" variant="outlined" />
                  </div>
                </form>
              </div>
              {/* <div className={styles.askButton}>
                  <V2Button css={{ width: "100%" }}>
                    <span>Ask the plan companion</span>{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                    >
                      <path
                        d="M16.7074 14.4486C13.114 14.4486 10.1994 11.5339 10.1994 7.94062C10.1994 7.83862 10.117 7.75232 10.0111 7.75232C9.90515 7.75232 9.82277 7.8347 9.82277 7.94062C9.82277 11.5339 6.90809 14.4486 3.31476 14.4486C3.21277 14.4486 3.12646 14.531 3.12646 14.6369C3.12646 14.7428 3.20884 14.8252 3.31476 14.8252C6.90809 14.8252 9.82277 17.7399 9.82277 21.3332C9.82277 21.4352 9.90515 21.5215 10.0111 21.5215C10.117 21.5215 10.1994 21.4391 10.1994 21.3332C10.1994 17.7399 13.114 14.8252 16.7074 14.8252C16.8094 14.8252 16.8957 14.7428 16.8957 14.6369C16.8957 14.531 16.8133 14.4486 16.7074 14.4486Z"
                        fill="white"
                      />
                      <path
                        d="M20.0536 7.79152C18.2884 7.79152 16.8565 6.35968 16.8565 4.59439C16.8565 4.5434 16.8134 4.50024 16.7624 4.50024C16.7114 4.50024 16.6682 4.5434 16.6682 4.59439C16.6682 6.35968 15.2364 7.79152 13.4711 7.79152C13.4201 7.79152 13.377 7.83467 13.377 7.88566C13.377 7.93666 13.4201 7.97981 13.4711 7.97981C15.2364 7.97981 16.6682 9.41165 16.6682 11.1769C16.6682 11.2279 16.7114 11.2711 16.7624 11.2711C16.8134 11.2711 16.8565 11.2279 16.8565 11.1769C16.8565 9.41165 18.2884 7.97981 20.0536 7.97981C20.1046 7.97981 20.1478 7.93666 20.1478 7.88566C20.1478 7.83467 20.1046 7.79152 20.0536 7.79152Z"
                        fill="white"
                      />
                    </svg>
                  </V2Button>
                </div> */}
              <div className={styles.agentButton}>
                <V2Link afterIcon="chevron_right" href="#">
                  Chat with a Licensed Agent instead
                </V2Link>
              </div>
              <div className={styles.info}>
                Benefit and coverage answers are generated by AI and may contain
                errors or incomplete information.
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
